export const carousel_items = [
    {
        img: 'bk/carousel-4.jpg',
        title: 'Case Study: Optimizing OSA with ISP',
        desc: `Tackle On-Shelf Availability issues and empower in-store teams with RSi's In Store Power Solution`,
        btn: {
            txt: 'Learn More',
            color: 'green',
        },
        url: ""
    },
    {
        img: 'bk/carousel-5.jpg',
        title: 'Join US For Our Upcoming Webinar!',
        desc: `Taking A Deeper Dive Into DVoid & Store Compliance EGDs 5/7/2020 at 11 AM EST`,
        btn: {
            txt: 'Register Now',
            color: 'teal',
        },
        url: ""
    },
    {
        img: 'bk/carousel-6.jpg',
        title: 'The Future of E-commerce',
        desc: `Covid-19 has had a major impact on the CPG industry as a whole, especially E-commerce.
               In out piece, we explore the future implication`,
        btn: {
            txt: 'Read More',
            color: 'red',
        },
        url: ""
    }
];